'use client'
import { useTranslations } from 'next-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import { Button } from '@teqplay/ui'

import { Link } from '@/i18n/navigation'
import './VesselError.scss'

type TProps = {
  imo: string
  errorMessage?: string
}

export default function VesselError({ imo, errorMessage }: TProps) {
  const t = useTranslations('VesselError')

  return (
    <div className="vessel-error">
      <div className="vessel-error-content">
        <div className="vessel-error-icon">
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </div>
        <h1 className="vessel-error-title">{t('title')}</h1>
        <p className="vessel-error-message">{t('message', { imo })}</p>
        {errorMessage && process.env.NODE_ENV !== 'production' && (
          <details className="vessel-error-details">
            <summary>{t('technicalDetails')}</summary>
            <pre className="vessel-error-message-text">{errorMessage}</pre>
          </details>
        )}
        <div className="vessel-error-actions">
          <Button asChild variant="link" size="xl">
            <Link href="/">{t('backToHome')}</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
